import { useEffect } from 'react'
import type { FC } from 'react'
import { Route, Switch } from 'react-router-dom'
import { FormSection } from './Components/FormSection'
import { Section, FixedWidthContent } from '@alexanderathoodly/ui-library'
import { Confirmation } from './Components/Confirmation'
import Shape from '#/a-shapes/shape4.svg'
import DocumentIcon from '#/a-icons/document.svg'
import { GAAction } from '~/analytics/ga'
import { Footer } from '~/layouts/footer/footer'
import { Header } from '~/layouts/header/header'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { HelpPageHelmet } from './Components/Helmet'

const OfficeHelp: FC = () => {
	const { t } = useTranslation()
	useEffect(() => {
		GAAction({
			category: 'office_help',
			action: 'form_started',
		})
	}, [])

	const { pathname } = useLocation()
	const pathnames = pathname.split('/')
	const page = pathnames[1]
	const getLabel = () => {
		if (page !== 'kontorshjalpen') {
			return t(
				'Vi samlar 10 000 kontor på {{office_type}} i Sverige för att göra det enkelt att hitta och jämföra flexibla kontor. 100% kostnadsfri tjänst.',
				{
					office_type:
						page === 'kontorshotellshjalpen'
							? 'kontorshotell'
							: 'coworking spaces',
				}
			)
		}
		return t(
			'Fyll i era behov för att få förslag på kontor som passar er verksamhet och ta första steget mot ett nytt kontor att trivas och växa i'
		)
	}

	const getHeadline = () => {
		if (page !== 'kontorshjalpen') {
			return t(
				'Jämför offerter från olika {{office_type}} genom att svara på sex enkla frågor.',
				{
					office_type:
						page === 'kontorshotellshjalpen'
							? 'kontorshotell'
							: 'coworking spaces',
				}
			)
		}
		return t(
			'Vi tar fram förslag på kontor till er, svara på sex frågor kring era behov.'
		)
	}

	return (
		<div id="officehelp">
			<HelpPageHelmet />
			<Header />
			<Switch>
				<Route
					path={[
						`${t('/kontorshjalpen', { ns: 'url' })}/success`,
						`${t('/kontorshotellshjalpen', { ns: 'url' })}/success`,
						`${t('/coworkinghjalpen', { ns: 'url' })}/success`,
					]}
				>
					<Confirmation />
				</Route>
				<Route
					path={[
						t('/kontorshjalpen', { ns: 'url' }),
						t('/kontorshotellshjalpen', { ns: 'url' }),
						t('/coworkinghjalpen', { ns: 'url' }),
					]}
				>
					<Section
						id="form-section"
						shape={Shape}
						icon={DocumentIcon}
						label={getLabel()}
						headline={getHeadline()}
					>
						<FixedWidthContent>
							<FormSection />
						</FixedWidthContent>
					</Section>
				</Route>
			</Switch>
			<Footer />
		</div>
	)
}

export default OfficeHelp
